const styles = theme => ({
  titleHead: {
    color: '#342D3D',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    marginBottom: '25px',
    padding: '0 15px',
    '& h1': {
      fontWeight: '600',
      fontSize: '16px',
      [theme.breakpoints.down('md')]: {
        marginBottom: '25px',
      },
    },
    '& $textGray': {
      color: theme.palette.primary.darkGrey,
      fontWeight: '500',
    },
  },
  roundedButton: {
    padding: '20px',
    borderRadius: '0%',
    // height: '50px',
    // width: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  arrowWidth: {
    width: '20px',
  },
  textGray: {},
  avatar: {
    height: 61,
    width: 65,
    display: 'inline-flex',
    borderRadius: '0%',
  },
  title: {
    fontWeight: '600',
    marginBottom: '0',
    [theme.breakpoints.up('md')]: {
      marginBottom: '2px',
    },
  },
  subTitle: {},
  buyersList: {
    padding: '0 15px',
  },
  listItemContainer: {
    position: 'relative',
    marginBottom: '40px',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
    borderRadius: '0px',
    '&:last-child': {
      marginBottom: '32px',
    },
  },
  listItem: {
    paddingTop: '10px',
    paddingBottom: '6px',
    flexDirection: 'column',
  },
  selected: {
    border: `2px solid ${theme.palette.primary.lightADGMGreen}`,
    borderRadius: '0px',
  },
  listMainContent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  errorMsg: {
    padding: '12px',
    border: '1px solid #E95635',
    background: '#FDF0ED',
    fontSize: '12px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    borderRadius: '0px',
    '& a': {
      color: '#0496FF',
      textDecoration: 'none',
    },
  },
  listItemIcon: {
    minWidth: 'auto',
    marginRight: '11px',
  },
  itemCheckbox: {
    '& svg': {
      height: '30px',
      width: '30px',
    },
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
  },
  itemCheckboxIndeterminate: {
    color: '#000000 !important',
  },
  listItemText: {
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: '97px',
    '& $item': {
      padding: '0',
      overflow: 'hidden',
      marginBottom: '4px',
      marginRight: '12px',
      '& p': {
        fontSize: '14px',
        whiteSpace: 'normal',
      },
      '& $subTitle': {
        display: 'none',
      },
    },
    '& $avatarItem': {
      display: 'flex',
      alignItems: 'center',
      borderLeft: 'none',
      paddingLeft: '0px',
      width: '100%',
      marginBottom: '10px',
      '& > div p:last-child': {
        marginBottom: '0px',
      },
      '& $avatar': {
        height: 36,
        width: 36,
        marginRight: '9px',
      },
    },
    '& $title': {
      fontSize: '14px',
    },
    '& $subTitle': {
      color: theme.palette.primary.dim,
    },
  },
  item: {
    '& p:first-child': {
      color: '#484456',
    },
    '& p:last-child': {
      color: theme.palette.primary.adgmBlack,
    },
  },
  avatarItem: {},
  listItemAction: {
    right: '46px',
  },
  listItemActionModified: {
    right: '80px',
  },
  listItemActionArrow: {},
  badgeButton: {
    background: theme.palette.primary.infoBlueLight,
    color: theme.palette.primary.infoBlue,
    textTransform: 'none',
    border: '1px solid #1270B4',
    borderRadius: '0px',
    padding: '6px',
    width: '124px',
    '& p': {
      fontSize: '14px',
      fontWeight: 500,
    },
    '& span': {
      '& > span': {
        margin: '0px 2px',
      },
    },
  },
  badgeButtonModified: {
    background: theme.palette.primary.infoBlueLight,
    color: theme.palette.primary.infoBlue,
    textTransform: 'none',
    border: '1px solid #1270B4',
    borderRadius: '0px',
    padding: '6px',
    width: '90px',
    '& p': {
      fontSize: '14px',
      fontWeight: 500,
    },
    '& span': {
      '& > span': {
        margin: '0px 2px',
      },
    },
  },
  typeChip: {
    position: 'absolute',
    background: theme.palette.primary.adgmGreen,
    color: '#fff',
    fontSize: '12px',
    top: '-19px',
    height: '19px',
    minWidth: '72px',
    [theme.breakpoints.up('md')]: {
      left: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      right: '16px',
    },
  },
  badgePill: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    '& > div': {
      margin: '2px 0',
      lineHeight: '1.3',
    },
  },
  collapsedList: {
    background: '#fff',
  },
  collapsedListItem: {
    padding: '10px 5%',
  },
  collapsedListItemText: {
    gridTemplateColumns: '25% 20% 20% 20% 15% !important',
    '& > div:nth-child(4), & > div:nth-child(5)': {
      borderRight: 'none !important',
    },
  },
  collapsedAvatarItem: {
    '& > div:last-child': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  collapsedBadge: {
    width: '100%',
  },

  [theme.breakpoints.up('md')]: {
    titleHead: {
      flexWrap: 'nowrap',
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: '24px',
      padding: '0',
      '& h1': {
        fontSize: '1.5rem',
        '&:after': {
          height: '0',
          background: 'transparent',
        },
      },
      '& $textGray': {
        marginLeft: 'auto',
      },
    },
    propertiesList: {
      padding: '0',
    },
    listItem: {
      '& .MuiListItemText-root': {
        marginTop: '0px',
        marginBottom: '0px',
      },
    },
    listItemBuilding: {
      paddingRight: '10.4rem',
    },
    listItemText: {
      display: 'grid',
      gridTemplateColumns: '28% 18% 18% 18% 18%',
      alignItems: 'center',
      '& $item': {
        borderLeft: '1px solid #EBEEF3',
        padding: '0 10px',
        minWidth: 'auto',
        marginBottom: '0',
        '& $subTitle': {
          display: 'block',
        },
      },
      '& $avatarItem': {
        borderLeft: 'none',
        paddingLeft: '0px',
        width: 'auto',
        marginBottom: '0',
        '& $avatar': {
          height: 63,
          width: 63,
        },
      },
    },
    listItemTextBuilding: {
      gridTemplateColumns: '25% 17% 17% 12% 12% 17% !important',
      '& $item': {
        '&:last-child': {
          borderRight: '1px solid #EBEEF3',
        },
      },
    },
    badgePill: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0',
    },
    collapsedList: {
      background: '#F8F8F8',
    },
  },

  [theme.breakpoints.down('sm')]: {
    title: {
      fontSize: '16px',
    },
    listItemBuilding: {
      paddingRight: '16px',
      flexDirection: 'column',
    },
    listItemAction: {
      right: '0',
      width: '100%',
      position: 'static',
      padding: '0 16px 10px',
      transform: 'none',
      display: 'inline-block',
    },
    listItemActionModified: {
      right: '0',
      top: '5px',
      width: 'auto',
      position: 'absolute',
      padding: '0 16px 10px',
      transform: 'none',
      display: 'inline-block',
    },
    listItemActionArrow: {
      right: '0',
      bottom: '5px',
      width: 'auto',
      position: 'absolute',
      padding: '0 16px',
      transform: 'none',
      display: 'inline-block',
      top: 'unset',
    },
    badgeButton: {
      borderRadius: '0px',
      width: '100%',
      '& p': {
        fontSize: '12px',
        '& + span': {
          marginLeft: 'auto',
        },
      },
      '& span': {
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: '0px',
        '& > span': {
          margin: '0px 6px',
        },
      },
    },
    badgeButtonModified: {
      bottom: 0,
      borderRadius: '0px',
      width: '100%',
      '& p': {
        fontSize: '12px',
        '& + span': {
          marginLeft: 'auto',
        },
      },
      '& span': {
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: '0px',
        '& > span': {
          margin: '0px 6px',
        },
      },
    },
    listItemText: {
      '& $item': {
        color: theme.palette.primary.darkGrey,
        display: 'inline-flex',
        alignItems: 'center',
        '&:nth-child(6)': {
          width: '100%',
        },
        '& img': {
          marginRight: '4px',
        },
        '& svg': {
          width: '16px',
          marginRight: '4px',
        },
      },
      '& $avatarItem': {
        color: theme.palette.secondary.main,
      },
      '& $Localityitem': {
        width: '100%',
        flexWrap: 'wrap',
        // justifyContent: 'space-between',
      },
    },
    Localityitem: {},
    listItemIcon: {
      minWidth: 'auto',
      marginRight: '0',
      position: 'absolute',
      right: '0',
      top: '0',
    },
    collapsedListItem: {
      borderBottom: '1px solid #EBEEF3',
      '&:last-child': {
        borderBottom: '0',
      },
    },
    collapseListItemIcon: {
      minWidth: 'auto',
      marginRight: '0',
      position: 'absolute',
      right: '0',
      top: '0',
    },
    roundedButton: {
      padding: '15px',
      borderRadius: '0%',
      // height: '50px',
      // width: '50px',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    arrowWidth: {
      width: '15px',
    },
  },
});

export default styles;
